import Vue from "vue"

let itemModalMixin = {
    methods: {
        handleProductDeeplink() {
            if (this.$route.query.item_id) {
                if (this.$route.query.editing) {
                    this.$router.replace({ query: null })
                } else {
                    Vue.nextTick(() => {
                        this.$refs.itemModal.open()
                    })
                }
            }
        }
    },
    mounted: function () {
        this.handleProductDeeplink()
    },
    watch: {
        $route(to) {
            if (to.query.item_id) {
                this.$refs.itemModal.open()
            } else {
                this.$refs.itemModal.close()
            }
        }
    }
}

export default itemModalMixin
